// Entrinsia Type Check Functions
// Required Libraries
const util = require('util')
var _ = require('underscore')

// Debug Helper Function
const debug = (obj) => {
    return util.inspect(obj, false, null, true)
}

const isEmpty = (arg) => {
    for (var key in arg) {
        if (arg.hasOwnProperty(key)) {
            return false
        }
    }
    return true
}

const isArray = (arg) => {
    if (!isUndefined(arg) && !isNull(arg)) return arg.constructor === Array
    return false
}

const isBoolean = (arg) => {
    return typeof arg === 'boolean'
}

const isNumber = (arg) => {
    return typeof arg === 'number'
}

const isFloat = (arg) => {
    return Number(arg) === arg && arg % 1 !== 0
}

const isInt = (arg) => {
    return Number(arg) === arg && arg % 1 === 0
}

const isString = (arg) => {
    return typeof arg === 'string'
}

const isObject = (arg) => {
    return arg !== null && typeof arg === 'object'
}

const isNull = (arg) => {
    return arg === null
}

const isUndefined = (arg) => {
    return arg === undefined
}

const isEmptyString = (arg) => {
    if (!isNull(arg) && !isUndefined(arg)) {
        let testString = String(arg)
        return !testString.trim()
    }
    return false
}

const isEmptyObject = (arg) => {
    if (Object.keys(arg).length === 0 && arg.constructor === Object) return true
    else return false
}

const isEmptyArray = (arg) => {
    if (isUndefined(arg) || arg.length == 0) {
        return true
    } else {
        return false
    }
}

const field = (obj, key) => {
    let val = null
    if (obj.hasOwnProperty(key)) {
        if (!isUndefined(obj["key"]) && !isNull(obj["key"]) && !isEmptyString(obj["key"])) {
            val = obj["key"]
        }
    }
    return val
}

const isEqualObj = (obj1, obj2) => {
    let result = _.isEqual(obj1, obj2)
    return result
}

const isArrayOfObj = (arr1) => {
    let val = false
    if (isArray(arr1)) {
        if (isObject(arr1[0])) val = true
    }
    return val
}

// Isolate the incoming object and create a new one
// Provides protection against unintended side effects during object processing
const iso = (srcData) => {
    if (isUndefined(srcData) || isNull(srcData)) return null
    return JSON.parse(JSON.stringify(srcData))
}

// Check if value is true
const isTrue = (val) => {
    if (val === true) return true
    else return false
}

// Check if object has key
const hasKey = (key, obj) => {
    let found = obj.hasOwnProperty(key)
    return found
}

// Check if object is a promise
const isPromise = (val) => {
    return !!val && typeof val.then === 'function'
}

// Check if an object has a property and it is not empty
const propExistsNotEmpty = (prop, item) => {
    if (!item.hasProp(prop)) return false
    if (isArray(item.getVal(prop))) {
        if (isEmptyArray(item.getVal(prop))) return false
    }
    if (isString(item.getVal(prop))) {
        if (isEmptyString(item.getVal(prop))) return false
    }
    return true
}

// Check a setting on an object
function checkSetting(obj, setting, defaultValue) {
    let result = null
    if (obj === undefined) return defaultValue
    if (!obj.hasOwnProperty(setting)) result = defaultValue
    else result = obj[setting]
    return result
}


var check = {
    isEmpty,
    isArray,
    isBoolean,
    isNumber,
    isString,
    isObject,
    isEmptyObject,
    isNull,
    isUndefined,
    isEmptyString,
    isEmptyArray,
    isInt,
    isFloat,
    field,
    isEqualObj,
    iso,
    isArrayOfObj,
    isTrue,
    hasKey,
    isPromise,
    propExistsNotEmpty,
    checkSetting
}

export default check